// Generated by `yarn tokens:import --aos-ds` from the Figma component set "Widget/Punctuality/ChartTooltip/Direction" (19022:459741). Do not edit.

import type { FigmaGlyph } from '../../icons/glyph'

export type ContractProp =
    | { kind: 'enum'; values: readonly string[] }
    | { kind: 'boolean' }
    | { kind: 'text' }
    | { kind: 'instance_swap' }
    // A matrix can carry slots too — Modal/Footer has two.
    | { kind: 'slot' }

export type ContractComposition = { component: string; variants: readonly string[] }

// A place the Figma file contradicts itself, grouped by what it says. `count` is
// how many places say it; `property` and `stated` are set for an alignment the
// file states and does not draw.
export type ContractDisagreement = {
    note: string
    count: number
    property?: string
    stated?: string
}

export type ContractVariant = {
    container: string
    label: string
    // The surface, when the paint sits on a child rather than the root:
    // empty for every component that paints its own frame.
    box: string
    // Every named node the variant draws beyond those two, keyed by the
    // name Figma gives it. A key that reads as a value rather than a role
    // means the component is a composition, not a primitive.
    parts: Record<string, string>
    // The shape of every part that is one — a VECTOR drawn on top of
    // something the variant also paints, which the whole-variant `glyph`
    // cannot describe because that one requires no paint at all.
    glyphs: Record<string, FigmaGlyph>
    // The glyph the variant draws, inked separately from the label.
    icon: string
    // Applied in JS: `disabled:` never matches a react-native-web div, and
    // `:visited` exists only on an anchor.
    disabled: string
    visited: string
    // Which of `textStyleIds` each text part is set in. The ids are a set,
    // so a component with two says two exist and not which part uses which.
    partTextStyles: Record<string, string>
    // What this cell instantiates, and which variant of it.
    composes: readonly ContractComposition[]
}

export const widgetPunctualityCharttooltipDirectionContract = {
    component: 'Widget/Punctuality/ChartTooltip/Direction',
    nodeId: '19022:459741',
    section: 'Punctuality · Components',
    // Components a variant instantiates, with the variant keys used.
    // Where one of these carries the component's own paint rather than
    // a glyph, the classes below describe only what is left — Checkbox
    // swaps a whole box here.
    composes: [
        { component: 'Widget/Punctuality/ChartTooltip/FlightRow', variants: ['user=finavia'] },
    ],
    stateAxis: null,
    // Where the caller puts content. One `ReactNode` prop per name.
    slots: [] as readonly string[],
    // What the file says that its own drawing does not show.
    disagreeing: [
        { note: '3 labels with their own ink or style', count: 4 },
        { note: '4 labels with their own ink or style', count: 2 },
        { note: '5 labels with their own ink or style', count: 4 },
    ] as readonly ContractDisagreement[],
    textStyleIds: [
        'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
        'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
    ],
    props: {
        direction: { kind: 'enum', values: ['departures', 'arrivals'] },
        hour: {
            kind: 'enum',
            values: ['past', 'current', 'forecast', 'no prediction', 'no flights'],
        },
    },
    variants: {
        'direction=arrivals, hour=current': {
            container: 'gap-2xs w-[16.5rem] items-start',
            label: 'text-content-muted text-left',
            icon: '',
            disabled: '',
            visited: '',
            box: 'bg-flights-arrivals rounded-common w-[0.75rem] h-[0.75rem]',
            parts: {
                'header': 'gap-s items-center',
                'label': 'text-content-muted text-left',
                'value-group': 'gap-xs items-center',
                'dot': 'bg-flights-arrivals rounded-common w-[0.75rem] h-[0.75rem]',
                'value': 'gap-2xs items-start',
                'value 2': 'text-content-default text-left',
                'unit': 'text-content-muted text-left',
                'part-departed': 'text-content-muted text-left',
                'part-expected': 'text-content-muted text-left',
                'row-expected-1': 'gap-s items-start',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'label': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
                'value 2': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
                'unit': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
                'part-departed': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
                'part-expected': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [
                {
                    component: 'Widget/Punctuality/ChartTooltip/FlightRow',
                    variants: ['user=finavia'],
                },
            ],
        },
        'direction=arrivals, hour=forecast': {
            container: 'gap-2xs w-[16.5rem] items-start',
            label: 'text-content-muted text-left',
            icon: '',
            disabled: '',
            visited: '',
            box: 'bg-flights-arrivals rounded-common w-[0.75rem] h-[0.75rem]',
            parts: {
                'header': 'gap-s items-center',
                'label': 'text-content-muted text-left',
                'value-group': 'gap-xs items-center',
                'dot': 'bg-flights-arrivals rounded-common w-[0.75rem] h-[0.75rem]',
                'value': 'gap-2xs items-start',
                'value 2': 'text-content-default text-left',
                'unit': 'text-content-muted text-left',
                'summary': 'text-content-muted text-left',
                'row-1': 'gap-s items-start',
                'row-2': 'gap-s items-start',
                'row-3': 'gap-s items-start',
                'more': 'text-content-muted text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'label': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
                'value 2': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
                'unit': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
                'summary': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
                'more': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [
                {
                    component: 'Widget/Punctuality/ChartTooltip/FlightRow',
                    variants: ['user=finavia'],
                },
            ],
        },
        'direction=arrivals, hour=no flights': {
            container: 'gap-2xs w-[16.5rem] items-start',
            label: 'text-content-muted text-left',
            icon: '',
            disabled: '',
            visited: '',
            box: 'bg-flights-arrivals rounded-common w-[0.75rem] h-[0.75rem]',
            parts: {
                'header': 'gap-s items-center',
                'label': 'text-content-muted text-left',
                'value-group': 'gap-xs items-center',
                'dot': 'bg-flights-arrivals rounded-common w-[0.75rem] h-[0.75rem]',
                'value': 'gap-2xs items-start',
                'value 2': 'text-content-default text-left',
                'reason': 'text-content-muted text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'label': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
                'value 2': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
                'reason': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [],
        },
        'direction=arrivals, hour=no prediction': {
            container: 'gap-2xs w-[16.5rem] items-start',
            label: 'text-content-muted text-left',
            icon: '',
            disabled: '',
            visited: '',
            box: 'bg-flights-arrivals rounded-common w-[0.75rem] h-[0.75rem]',
            parts: {
                'header': 'gap-s items-center',
                'label': 'text-content-muted text-left',
                'value-group': 'gap-xs items-center',
                'dot': 'bg-flights-arrivals rounded-common w-[0.75rem] h-[0.75rem]',
                'value': 'gap-2xs items-start',
                'value 2': 'text-content-default text-left',
                'reason': 'text-content-muted text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'label': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
                'value 2': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
                'reason': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [],
        },
        'direction=arrivals, hour=past': {
            container: 'gap-2xs w-[16.5rem] items-start',
            label: 'text-content-muted text-left',
            icon: '',
            disabled: '',
            visited: '',
            box: 'bg-flights-arrivals rounded-common w-[0.75rem] h-[0.75rem]',
            parts: {
                'header': 'gap-s items-center',
                'label': 'text-content-muted text-left',
                'value-group': 'gap-xs items-center',
                'dot': 'bg-flights-arrivals rounded-common w-[0.75rem] h-[0.75rem]',
                'value': 'gap-2xs items-start',
                'value 2': 'text-content-default text-left',
                'unit': 'text-content-muted text-left',
                'summary': 'text-content-muted text-left',
                'row-1': 'gap-s items-start',
                'row-2': 'gap-s items-start',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'label': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
                'value 2': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
                'unit': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
                'summary': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [
                {
                    component: 'Widget/Punctuality/ChartTooltip/FlightRow',
                    variants: ['user=finavia'],
                },
            ],
        },
        'direction=departures, hour=current': {
            container: 'gap-2xs w-[16.5rem] items-start',
            label: 'text-content-muted text-left',
            icon: '',
            disabled: '',
            visited: '',
            box: 'bg-flights-departures rounded-common w-[0.75rem] h-[0.75rem]',
            parts: {
                'header': 'gap-s items-center',
                'label': 'text-content-muted text-left',
                'value-group': 'gap-xs items-center',
                'dot': 'bg-flights-departures rounded-common w-[0.75rem] h-[0.75rem]',
                'value': 'gap-2xs items-start',
                'value 2': 'text-content-default text-left',
                'unit': 'text-content-muted text-left',
                'part-departed': 'text-content-muted text-left',
                'row-departed-1': 'gap-s items-start',
                'part-expected': 'text-content-muted text-left',
                'row-expected-1': 'gap-s items-start',
                'row-expected-2': 'gap-s items-start',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'label': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
                'value 2': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
                'unit': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
                'part-departed': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
                'part-expected': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [
                {
                    component: 'Widget/Punctuality/ChartTooltip/FlightRow',
                    variants: ['user=finavia'],
                },
            ],
        },
        'direction=departures, hour=forecast': {
            container: 'gap-2xs w-[16.5rem] items-start',
            label: 'text-content-muted text-left',
            icon: '',
            disabled: '',
            visited: '',
            box: 'bg-flights-departures rounded-common w-[0.75rem] h-[0.75rem]',
            parts: {
                'header': 'gap-s items-center',
                'label': 'text-content-muted text-left',
                'value-group': 'gap-xs items-center',
                'dot': 'bg-flights-departures rounded-common w-[0.75rem] h-[0.75rem]',
                'value': 'gap-2xs items-start',
                'value 2': 'text-content-default text-left',
                'unit': 'text-content-muted text-left',
                'summary': 'text-content-muted text-left',
                'row-1': 'gap-s items-start',
                'row-2': 'gap-s items-start',
                'row-3': 'gap-s items-start',
                'more': 'text-content-muted text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'label': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
                'value 2': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
                'unit': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
                'summary': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
                'more': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [
                {
                    component: 'Widget/Punctuality/ChartTooltip/FlightRow',
                    variants: ['user=finavia'],
                },
            ],
        },
        'direction=departures, hour=no flights': {
            container: 'gap-2xs w-[16.5rem] items-start',
            label: 'text-content-muted text-left',
            icon: '',
            disabled: '',
            visited: '',
            box: 'bg-flights-departures rounded-common w-[0.75rem] h-[0.75rem]',
            parts: {
                'header': 'gap-s items-center',
                'label': 'text-content-muted text-left',
                'value-group': 'gap-xs items-center',
                'dot': 'bg-flights-departures rounded-common w-[0.75rem] h-[0.75rem]',
                'value': 'gap-2xs items-start',
                'value 2': 'text-content-default text-left',
                'reason': 'text-content-muted text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'label': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
                'value 2': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
                'reason': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [],
        },
        'direction=departures, hour=no prediction': {
            container: 'gap-2xs w-[16.5rem] items-start',
            label: 'text-content-muted text-left',
            icon: '',
            disabled: '',
            visited: '',
            box: 'bg-flights-departures rounded-common w-[0.75rem] h-[0.75rem]',
            parts: {
                'header': 'gap-s items-center',
                'label': 'text-content-muted text-left',
                'value-group': 'gap-xs items-center',
                'dot': 'bg-flights-departures rounded-common w-[0.75rem] h-[0.75rem]',
                'value': 'gap-2xs items-start',
                'value 2': 'text-content-default text-left',
                'reason': 'text-content-muted text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'label': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
                'value 2': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
                'reason': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [],
        },
        'direction=departures, hour=past': {
            container: 'gap-2xs w-[16.5rem] items-start',
            label: 'text-content-muted text-left',
            icon: '',
            disabled: '',
            visited: '',
            box: 'bg-flights-departures rounded-common w-[0.75rem] h-[0.75rem]',
            parts: {
                'header': 'gap-s items-center',
                'label': 'text-content-muted text-left',
                'value-group': 'gap-xs items-center',
                'dot': 'bg-flights-departures rounded-common w-[0.75rem] h-[0.75rem]',
                'value': 'gap-2xs items-start',
                'value 2': 'text-content-default text-left',
                'unit': 'text-content-muted text-left',
                'summary': 'text-content-muted text-left',
                'row-1': 'gap-s items-start',
                'row-2': 'gap-s items-start',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'label': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
                'value 2': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
                'unit': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
                'summary': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [
                {
                    component: 'Widget/Punctuality/ChartTooltip/FlightRow',
                    variants: ['user=finavia'],
                },
            ],
        },
    },
} as const satisfies {
    component: string
    nodeId: string
    section: string
    composes: readonly ContractComposition[]
    stateAxis: string | null
    slots: readonly string[]
    disagreeing: readonly ContractDisagreement[]
    textStyleIds: readonly string[]
    props: Record<string, ContractProp>
    variants: Record<string, ContractVariant>
}
